import { IconArrowUpRight } from "central-icons-outlined/IconArrowUpRight";
import { NewTabHint } from "@/components/mdx/anchor";
import { cn } from "@/lib/utils";

interface DemoCaptionProps {
  children: React.ReactNode;
  className?: string;
  href?: string;
}

export default function DemoCaption({
  children,
  href,
  className,
}: DemoCaptionProps) {
  if (href) {
    return (
      <div
        className={cn(
          "group mt-4 flex items-center justify-center gap-1 text-center",
          className
        )}
      >
        <a
          className="text-[13px] text-gray-1000 transition-colors duration-150 ease-out group-hover:text-gray-1200"
          href={href}
          rel="noopener"
          target="_blank"
        >
          {children}
          <NewTabHint />
        </a>
        <IconArrowUpRight
          aria-hidden="true"
          className="size-3.5 text-gray-1000 transition-colors duration-150 ease-out group-hover:text-gray-1200"
        />
      </div>
    );
  }

  return (
    <div
      className={cn(
        "mt-4 flex w-full items-center justify-center text-center",
        className
      )}
    >
      <p className="max-w-xl text-pretty text-[13px] text-gray-1000">
        {children}
      </p>
    </div>
  );
}
